import * as queryString from 'query-string';

function getEnv() {
  // eslint-disable-next-line no-underscore-dangle
  return (typeof window !== 'undefined' && window._env_) || {};
}

export function getQueryParams() {
  if (typeof window === 'undefined') {
    return {};
  }

  return queryString.parse(window.location.search);
}

function isTrue(value) {
  return value === true || value === 'true';
}

function is3ESchool() {
  return getQueryParams().isOneRosterActivatedSchool === 'true';
}

export function getAnalyticsBuildConfig() {
  const env = getEnv();

  return {
    environment: env.env || 'production',
    posthogEnabled: isTrue(env.POSTHOG_ENABLED),
    trackingGroups: undefined,
    teacherTotterEnabled: isTrue(env.TEACHER_TOTTER_ENABLED) && is3ESchool(),
    teacherTotterSyncUrl: env.TEACHER_TOTTER_SYNC_URL,
    identityGatewayUrl: env.IDENTITY_GATEWAY_URL,
    getAppAuthToken: () => getQueryParams().authToken || null
  };
}
